import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ServiceTransportModalForm from "../../Forms/ServiceForms/ServiceTransportModalForm/ServiceTransportModalForm";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
const ServiceTransportModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:service.serviceTransport"), error: false }
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const formName = "ServiceTransportModalForm";
  const { handleHide, show } = props;
  const buttons = () => {
    return (
      <>
        <BMXButton
          data-cy="save"
          type="subbmit"
          onClick={() => setIsSubmit(true)}
          bmxclass="Success"
          form={formName}
        >
          {t("global:save")}
        </BMXButton>
      </>
    );
  };

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };


  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"700px"}
      height={"600px"}
      onClose={handleHide}
      header={props.header}
      buttons={buttons()}
      steps={steps}
    >
      <ServiceTransportModalForm
        steps={steps}
        step={step}
        isSubmit={isSubmit}
        setStep={setStep}
        setErrorHeader={setErrorHeader}
        handleHide={handleHide}
        formName={formName}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "ServiceTransportModal" })(ServiceTransportModal);
